import { useQuery } from '@tanstack/react-query';
import ClientsService from '../../services/ClientsService';
import MediaUploadsService from '../../services/MediaUploadsService';

export const clientKeys = {
  all: ['clients'],
  details: () => [...clientKeys.all, 'detail'],
  detail: (id) => [...clientKeys.details(), id],
  status: (id) => [...clientKeys.all, 'status', id],
  historic: () => [...clientKeys.all, 'historic'],
  historicModels: () => [...clientKeys.historic(), 'models'],
  historicCities: () => [...clientKeys.historic(), 'cities'],
};

export function useClientById(id) {
  return useQuery({
    queryKey: clientKeys.detail(id),
    queryFn: () => ClientsService.findById(id),
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000,
    retry: 2,
  });
}

export function useClientStatus(id) {
  return useQuery({
    queryKey: clientKeys.status(id),
    queryFn: () => ClientsService.findByStatus(id),
    enabled: !!id,
    staleTime: 2 * 60 * 1000, // 2 minutos
    gcTime: 10 * 60 * 1000,
    retry: 2,
  });
}

export function useHistoricModels() {
  return useQuery({
    queryKey: clientKeys.historicModels(),
    queryFn: async () => {
      const key = process.env.REACT_APP_LOCAL_STORAGE_HISTORIC;

      const histModel = JSON.parse(localStorage.getItem(key) || '[]');

      if (histModel.length === 0) {
        return [];
      }

      const updatedHistModel = await Promise.all(
        histModel.map(async (model) => {
          const { urls } = await MediaUploadsService.listVerification(model.id);
          return { ...model, urls };
        })
      );

      return updatedHistModel;
    },
    staleTime: 2 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 1,
  });
}

export function useHistoricCities() {
  return useQuery({
    queryKey: clientKeys.historicCities(),
    queryFn: () => {
      const key = process.env.REACT_APP_LOCAL_STORAGE_HISTORIC_CITY;

      const histCity = JSON.parse(localStorage.getItem(key) || '[]');
      return histCity;
    },
    staleTime: 2 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 1,
  });
}
